import React, { useState, useEffect } from "react";
import { useQuery, useQueryClient } from 'react-query'
import { getResultRSC_H2H } from "data/Querys"
import ScoreHorizontal from 'components/common/ScoreHorizontal'
import Loader from 'components/general/Loader'
import { getSportCodeEntityObjects } from 'components/common/SportCode'
import { findArray } from 'helpers/utils'
import TkwPbp from "components/sports/tkw/views/TkwPbp";
import TkwScoreboard from "components/sports/tkw/views/TkwScoreboard";
import Referees from 'components/general/Referees'
import NotAvailable from "components/common/NotAvailable";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const TkwContext = () => {
    const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const queryClient = useQueryClient();
    const [periodsOrder, setPeriodsOrder] = useState()
    useEffect(() => {
        const dataSportCodes = queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes;
        const periodsCodes = getSportCodeEntityObjects(dataSportCodes, mirs_discipline, '@Period');
        const periodsOrder_ = periodsCodes ? periodsCodes?.map(p => ({ period: p.sportCode, order: parseInt(p.order) }))?.sort((a, b) => a.order - b.order) : [];
        setPeriodsOrder(periodsOrder_)
        // eslint-disable-next-line
    }, [])

    //datos para el marcador y estadisticas
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language],
            queryFn: getResultRSC_H2H,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            onError: (error) =>
                console.error(`Something went wrong: ${error.message}`),
        });

    if (isError) { return <NotAvailable />; }
    if (isLoading && !periodsOrder) { return <Loader />; }
    if (!data?.results) { return <NotAvailable /> }

    //console.log(data)

    const filtersQualRule = {
        ei_type: ['UI'],
        ei_code: ['QUAL_RULE']
    };

    let qualRule = data?.results?.extendedInfos && findArray(data.results.extendedInfos, filtersQualRule).ei_value;
    const resultStatus = data?.results?.status?.code;
    let bodyMiddle
    let score

    bodyMiddle = <TkwScoreboard data={data} status={resultStatus} mirs_discipline={mirs_discipline} />

    score = <ScoreHorizontal
        data={data}
        scoreBody={{
            top: <></>,
            middle: <>{bodyMiddle}</>
        }}
    />

    return (
        <>
            <div className='mirs-page-container'>
            <div className="d-flex  navbar-light  results-Header">
                <div className="flex-grow-1"> <h2>{data?.results?.eventUnit?.description}</h2></div>
                {/* <Navbar setPage={setPage} />*/}
            </div>
            <div>{data.results.date}</div>
            <div className='my-5'>
                {score}
            </div>
            {/*<div>Current split: {currentSplit}--{configEvent.sortBy[0].id}/{configEvent.sortBy[0].desc ? 'true' : 'false'}</div>*/}
            {qualRule ? <div className='p-2 m-4 card'>{qualRule}</div> : ''}
            {data?.results?.playByPlay &&
                <TkwPbp data={data} periodsOrder={periodsOrder} />
            }
            {data?.results?.officials &&
                <Referees data={data?.results?.officials} />
            }
            </div>
        </>
    )

}

export default TkwContext;